<template>
    <div class="CalculatorHome">
        <h1 class="CalculatorHome__title h1">{{ this.title }}</h1>
        <p class="CalculatorHome__sub-title">{{ subHeading }}</p>
        <slot />
        <ul class="CalculatorHome__options">
            <li class="CalculatorHome__option" @click="$emit('start', 'detailed')">
                <big-button :alt="'Start ' + this.title" :icon="calculator" class="BigButton--rev"> </big-button>
                <span class="CalculatorHome__option-prompt">Try the {{ title }}</span>
            </li>
        </ul>
        <div class="CalculatorHome__intro-copy" v-html="introCopy"></div>
    </div>
</template>

<script>
import BigButton from '../components/buttons/BigButton.vue';
import calculator from '@/assets/icons/calc.svg';
import * as track from '@/utilities/tracking';

export default {
    name: 'CalculatorHome',
    components: {
        BigButton
    },
    props: {
        title: {
            type: String,
            required: true
        },
        subHeading: {
            type: String,
            required: true
        },
        introCopy: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            calculator
        };
    },
    mounted() {
        if (this.$route.path.includes('income')) {
            track.startIncome();
        } else {
            track.startLife();
        }
    }
};
</script>

<style scoped lang="scss">
.CalculatorHome {
    text-align: center;
}

.CalculatorHome__title {
    margin-bottom: 0.5em;
}

.CalculatorHome__sub-title {
    margin-bottom: 1.1em;
}

.CalculatorHome__intro-copy {
    margin-top: 1rem;
}

.CalculatorHome__option-prompt {
    max-width: 220px;
    display: block;
    margin: 0 auto;
    text-decoration: underline;
    text-decoration-color: #004346;
    font-size: 18px;
    font-weight: 800;
    cursor: pointer;
}

.CalculatorHome__options {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-left: 0;
    margin-top: 10px;
    color: #000;
    list-style: none;

    @media screen and (min-width: 767px) {
        flex-direction: row;
        margin-top: 50px;
        padding-bottom: 20px;
    }
}

.CalculatorHome__option {
    padding-bottom: 20px;
    padding-top: 25px;
    max-width: 300px;

    @media screen and (min-width: 767px) {
        max-width: 350px;
        padding-right: 60px;
        padding-left: 0;
        padding-bottom: 0px;
        padding-top: 0px;
    }
}

.CalculatorHome__option:last-child {
    @media screen and (min-width: 767px) {
        padding-right: 0px;
    }
}
</style>
